import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_INCOMPLETE_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_INCOMPLETE_DETAILS_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {UploadedFileModel} from './useGetUploadedFileInfo';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface IncompleteDetailsResponse {
  supportingDocuments: UploadedFileModel[];
  passportPhoto: UploadedFileModel;
  remarks: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: IncompleteDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetIncompleteDetails = ({uuid, onSuccess, onError}: Input) => {
  const getIncompleteDetails = async () => {
    const res = await axiosClient.get<IncompleteDetailsResponse>(
        GET_NON_NATIONAL_INCOMPLETE_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_NON_NATIONAL_INCOMPLETE_DETAILS_QUERY_KEY, getIncompleteDetails, {
    onSuccess,
    onError,
  });
};
